import { render, staticRenderFns } from "./AttributeNFTImage.vue?vue&type=template&id=7ddf6d6a&"
import script from "./AttributeNFTImage.vue?vue&type=script&lang=js&"
export * from "./AttributeNFTImage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports